import {WorkBooking, WorkBookingRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell} from "@mui/material";
import {dateToString} from "../../../../components/utils/dates";

export const WorkBookingListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<WorkBooking> = {
		title: "Reservas de plazas",
		onClick: "/app/admin/employee/workbooking",
		headers: [
			{title: "Fecha"},
			{title: "Centro"},
			{title: "Persona"},
			{title: "Plazas"}
		],
		decorator: (bean: WorkBooking) =>
			<>
				<TableCell>{dateToString(bean.bookingDate)}</TableCell>
				<TableCell>{bean.workCenter.name}</TableCell>
				<TableCell>{bean.person.surnamesAndName}</TableCell>
				<TableCell>{bean.places}</TableCell>
			</>,
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(WorkBookingRestControllerApiFactory);
			return ctrl.pageWorkBooking(currentPage, size, undefined, undefined, undefined,
				undefined, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};